import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import { IconsCreateTest } from '@edulastic/icons'
import { segmentApi } from '@edulastic/api'
import { WidgetWrap } from './styled'
import { widgetKeys } from './constants'
import {
  isGcpsDistrictSelector,
  isPremiumUserSelector,
  isVideoQuizAndAIEnabledSelector,
} from '../../../../../src/selectors/user'
import EduAIQuiz from '../../../../../AssessmentCreate/components/CreateAITest'

const Widget = ({
  segmentEvent,
  icon,
  text,
  link,
  aiTest,
  videoQuiz,
  isVideoQuizAndAIEnabled,
  history,
  isGcpsDistrictExcludingDemoUsers,
  widgetKey,
}) => {
  const Icon = IconsCreateTest[icon]
  const handleClick = () => {
    if (segmentEvent?.name) {
      segmentApi.genericEventTrack(segmentEvent.name, {
        ...(segmentEvent?.data || {}),
      })
    }
    if (link) {
      history.push(link)
    }
  }

  if (aiTest) {
    return (
      <WidgetWrap data-cy="Use AI" onClick={handleClick} innerStyle>
        <EduAIQuiz displayScreen="dashboard" isILPFlow>
          <Icon />
          <p>{text}</p>
        </EduAIQuiz>
      </WidgetWrap>
    )
  }

  if (videoQuiz && !isVideoQuizAndAIEnabled) {
    return null
  }

  // dont show google form test for GCPS district excluding demo users
  //  since we are showing content converter
  if (
    isGcpsDistrictExcludingDemoUsers &&
    widgetKey === widgetKeys.GOOGLE_FORM_TEST
  ) {
    return null
  }

  return (
    <WidgetWrap data-cy={text} onClick={handleClick}>
      <Icon />
      <p>{text}</p>
    </WidgetWrap>
  )
}

const enhance = compose(
  withRouter,
  connect(
    (state) => ({
      isVideoQuizAndAIEnabled: isVideoQuizAndAIEnabledSelector(state),
      isGcpsDistrictExcludingDemoUsers: isGcpsDistrictSelector(state, true),
      isPremiumsUser: isPremiumUserSelector(state),
    }),
    null
  )
)

export default enhance(Widget)
